import { render, staticRenderFns } from "./RegrasDeOtimizacao.vue?vue&type=template&id=1ade3cc7&scoped=true"
import script from "./RegrasDeOtimizacao.vue?vue&type=script&lang=js"
export * from "./RegrasDeOtimizacao.vue?vue&type=script&lang=js"
import style0 from "./RegrasDeOtimizacao.vue?vue&type=style&index=0&id=1ade3cc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ade3cc7",
  null
  
)

export default component.exports